module.exports = __webpack_public_path__ + "static/media/bunu_with_comp.5d35da2f.gif";